"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediaPlayer = void 0;

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var YoutubeContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n  padding-top: 56.25%;\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n"], ["\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n  padding-top: 56.25%;\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n"])));
var SpotifyContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n  padding-top: 56.25%;\n  min-height: 15rem;\n  max-height: 350px;\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n"], ["\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n  padding-top: 56.25%;\n  min-height: 15rem;\n  max-height: 350px;\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n"])));
var StyledIframe = styled_components_1.default.iframe(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n"])));

var MediaPlayer = function MediaPlayer(_a) {
  var url = _a.url,
      title = _a.title;
  var isSpotifyLink = url.includes('spotify');
  var Container = isSpotifyLink ? SpotifyContainer : YoutubeContainer;
  return react_1.default.createElement(Container, null, react_1.default.createElement(StyledIframe, {
    "data-testid": isSpotifyLink ? 'spotify-player' : 'youtube-player',
    src: url,
    frameBorder: "0",
    allow: "accelerometer; encrypted-media; gyroscope; picture-in-picture",
    allowFullScreen: true,
    title: title
  }));
};

exports.MediaPlayer = MediaPlayer;
var templateObject_1, templateObject_2, templateObject_3;